import type { ConnectionShare } from "./useFormatConnectionShares";

// The BFF echoes shareType back verbatim from the request (e.g. "group", not "team"), so this
// matches on the same string rather than ConnectionShareType.
export function getFailedShareName(
  failedShare: { id: string; shareType: string },
  shares: ConnectionShare[],
) {
  const match = shares.find(
    (share) =>
      String(share.id) === failedShare.id &&
      share.shareType === failedShare.shareType,
  );
  return match?.name || failedShare.id;
}
